import { render, staticRenderFns } from "./BidsPage.vue?vue&type=template&id=69d82744"
import script from "./BidsPage.vue?vue&type=script&lang=js"
export * from "./BidsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports